export default __webpack_public_path__ + "static/Artificial_Light_Outdoor_5120kbps-2feabf92ffb42331670e20a91354023a.avif";